import { PaymentMethod } from "@omni/types/components/payment/paymentMethod.model";
import { CheckoutStyles } from "@omni/ui/brand/checkout/checkout.styles";
import { Button } from "@omni/ui/components/Button/button.component";
import { useSelector } from "react-redux";

import { PaymentMethodsFormValues } from "@/components/Checkout/Payment/payment.schema";
import { Container } from "@/components/General/Grid/container.component";
import { isLoading } from "@/redux/modules/api/data/checkout/payment/payment.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import GiftCardPaymentContainer from "./giftCardForm.container";

type GiftCardPaymentProps = {
    onSubmit: ({ code }: PaymentMethodsFormValues) => void;
    payedWithGiftCard: boolean;
    paymentMethods: Array<PaymentMethod>;
};

const GiftCardPayment = ({
    onSubmit,
    payedWithGiftCard,
    paymentMethods
}: GiftCardPaymentProps) => {
    const { t } = useGranite();

    const loading = useSelector(isLoading);

    const handleOnClick = () => {
        const code = paymentMethods.at(0)?.code;
        if (code) {
            onSubmit({ code });
        }
    };

    return (
        <Container>
            <GiftCardPaymentContainer />
            {payedWithGiftCard && (
                <Button
                    type="button"
                    color={CheckoutStyles.submitButton?.color || "success"}
                    onClick={handleOnClick}
                    loading={loading}
                >
                    {t("checkout.psp.paymentMethods.submit.label")}
                </Button>
            )}
        </Container>
    );
};

export { GiftCardPayment };
